/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'link2': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" _fill="#C4FFF9" d="M93.75 26l11.133 11.133-28.125 28.125-4.3 4.492 8.788 8.79 4.493-4.302 28.124-28.124 11.133 11.133v-31.25h-31.25l.004.003zM25 38.5V126h87.5V76H100v37.5H37.5V51H75V38.5H25z"/>'
  }
})
